import { AfterViewInit, Component, OnInit, OnDestroy, ViewChild} from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { DataTableDirective } from 'angular-datatables';
import { AlertService, MemberListService,AppService } from '../_services/index';
import {NgbModal, NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-member-list',
  templateUrl: './member-list.component.html',
  styles: []
})
export class MemberListComponent implements OnInit {

  @ViewChild(DataTableDirective, {static: false})
  dtElement: DataTableDirective;
  dtOptions: DataTables.Settings = {}; //  DataTable
  dtTrigger = new Subject(); //  DataTable

  memberList: any[] = []; // Table Data list
  closeResult: string; // Modal Close

  constructor(
              public router: Router,
              private dataService:MemberListService,
              private alertService: AlertService,
              private AppService: AppService,
              private modalService: NgbModal
            ) { }
    
  modalReference:NgbActiveModal;
  modalTitle:string;
  showloding = true;
  lodingImage = false;
  ngOnInit() {
    this.allMember();
  }

  allMember(){
    this.loadShow();
    this.dataService.getAllMember()
        .pipe().subscribe(
          data => { this.memberList = data['member'];
          //console.log(data['member']);
          // this.dtTrigger.next(); // Data Table          
          this.rerender();
          this.loadHide();
        });
     }

  openMemberViewPage(id) {
    this.router.navigate(['member-view/' + id]);
  }

  
  delete(id){
    if(confirm("Are you sure you want to active/inactive the member")) {
      this.dataService.deleteMember(id)
          .pipe().subscribe(data =>{
            if(data['status']==200){
              // this.dtTrigger = new Subject(); //  DataTable
              this.alertService.success('Member status updated successfully', true);
              this.allMember();
            }else{
              this.alertService.error('Member error');
            }
          },error =>{
            this.alertService.error(error);
          });
        }
      }
  
  loadShow(){
    this.showloding = true;
    this.lodingImage = false;
  }

  loadHide(){
    this.showloding = false;
    this.lodingImage = true;
  }

  ngAfterViewInit(): void {
    this.dtTrigger.next();
  }

  ngOnDestroy(): void {
    // Do not forget to unsubscribe the event
    this.dtTrigger.unsubscribe();
  }

  rerender(): void {
    this.dtElement.dtInstance.then((dtInstance: DataTables.Api) => {
      // Destroy the table first
      dtInstance.destroy();
      // Call the dtTrigger to rerender again
      this.dtTrigger.next();
    });
  }

}
